import styled from "styled-components";
import { FaGithubSquare } from "react-icons/fa";
import { AiFillLinkedin } from "react-icons/ai";

export const FooterContainer = styled.div`
  background: #272727;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: -2;
  bottom: 0;
  width: 100%;
  position: fixed;
  height: 200px;
  @media screen and (max-width: 820px) {
    height: 350px;
    display: flex;
    justify-content: center;
  }
`;

export const FooterLinksItems = styled.div`
  display: flex;
  margin: 16px;
  text-align: center;
  width: 160px;
  box-sizing: border-box;
  color: #fff;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 820px) {
    margin: 0;
    padding: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
`;

export const FooterTitle = styled.h1`
  color: ${({ light }) => (light ? "white" : "#52b2bf")};
  font-size: 50px;
  margin-bottom: 20px;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
  text-align: center;

  @media screen and (max-width: 820px) {
    margin-bottom: 0px;
    font-size: 40px;
    @media screen and (max-width: 420px) {
      max-width: 400px;
    }
  }
`;

export const FooterLinkMedia = styled.div`
  margin-bottom: 16px;

  cursor: pointer;
  text-decoration: none;
  font-size: 2.5rem;
  display: flex;
  align-items: center;
  @media screen and (max-width: 820px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const FooterLinkIcon = styled.a`
  color: ${({ light }) => (light ? "white" : "#f7f8fa")};
  &:hover {
    color: ${({ light }) => (light ? "#e57373" : "#52b2bf")};
    transition: 0.3s ease-out;
  }
`;

export const FooterLinkedinIcon = styled(AiFillLinkedin)`
  margin-left: 0.5rem;
`;

export const FooterGithubinIcon = styled(FaGithubSquare)`
  margin-left: 0.5rem;
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
  @media screen and (max-width: 820px) {
    margin-bottom: 0px;
  }
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  max-width: 1000px;
  margin: 40px auto 0 auto;

  @media screen and (max-width: 820px) {
    flex-direction: column;
    margin: 10px auto 0 auto;
  }
`;

export const BottomToTopButton = styled.button`
  height: 60px;
  width: 60px;
  position: fixed;
  bottom: 3%;
  right: 2%;
  background-color: #c20000;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  opacity: 0.7;
  border: 4px solid #ef9a9a;
`;

export const SocialLogo = styled.a`
  color: ${({ light }) => (light ? "white" : "#f7f8fa")};
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 2rem;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  &:hover {
    color: ${({ light }) => (light ? "#e57373" : "#52b2bf")};
    transition: 0.3s ease-out;
  }
`;

export const SocialIcon = styled.img`
  margin-right: 10px;
  width: 4rem;
  @media screen and (max-width: 960px) {
    width: 3rem;
    @media screen and (max-width: 320px) {
      width: 2.5rem;
    }
  }
`;

export const WebSiteRights = styled.p`
  color: ${({ light }) => (light ? "white" : "#f7f8fa")};
  margin-bottom: 16px;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;

  &:hover {
    color: ${({ light }) => (light ? "#e57373" : "#52b2bf")};
    transition: 0.3s ease-out;
  }
`;
